import { faCar, faCow, faSeedling, faTree, faWater, type IconDefinition } from "@fortawesome/free-solid-svg-icons";
import type { CampsiteEnvironment } from "../types/graphql/graphql";

export const environementLabels = {
  car_access: "activerecord.attributes.campsite.car_access",
  env_forest: "activerecord.attributes.campsite.env_forest",
  env_lake: "activerecord.attributes.campsite.env_lake",
  env_meadow: "activerecord.attributes.campsite.env_meadow",
  env_river: "activerecord.attributes.campsite.env_river",
  env_stream: "activerecord.attributes.campsite.env_stream",
  env_willow: "activerecord.attributes.campsite.env_willow",
} as const satisfies Record<CampsiteEnvironment, string>;

export const environementIcons: { [key in CampsiteEnvironment]?: IconDefinition } = {
  car_access: faCar,
  env_forest: faTree,
  env_lake: faWater,
  env_meadow: faSeedling,
  env_river: faWater,
  env_stream: faWater,
  env_willow: faCow,
} as const satisfies Record<CampsiteEnvironment, IconDefinition>;
